module.exports = __webpack_public_path__ + "images/ajax-loader.gif";


//////////////////
// WEBPACK FOOTER
// ./images/ajax-loader.gif
// module id = 19
// module chunks = 1